(ns hai.library.prompts.helper
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def ->label :ai-prompt/title)

(def icon icons/outlined-library_books)

(defn ->icon
  [_prompt]
  icon)

(defn ->tint
  [_prompt]
  t/--colour-rasberry-30)
